import React from "react";
import { Calendar, MapPin, ArrowRight } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1651514645933-c26e0eb4ace3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjb21tdW5pdHklMjBnYXRoZXJpbmclMjBwZW9wbGV8ZW58MHx8fHwxNzg0OTQ2NzA5fDA&ixlib=rb-4.1.0&q=85";

function formatEventDate(iso) {
  try {
    const d = new Date(iso);
    return {
      day: d.toLocaleDateString("fr-FR", { day: "2-digit" }),
      month: d.toLocaleDateString("fr-FR", { month: "short" }).replace(".", ""),
      time: d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }),
      full: d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" }),
    };
  } catch {
    return { day: "--", month: "--", time: "", full: iso };
  }
}

export default function EventsSection({ events = [] }) {
  return (
    <section id="evenements" className="py-24 lg:py-32 bg-[#FAFAFA] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="sticky top-32">
              <div className="inline-flex items-center gap-2 text-gold-dark text-xs tracking-[0.3em] uppercase mb-4">
                <Calendar className="w-3.5 h-3.5" /> Agenda
              </div>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-deepblue-900 font-semibold leading-tight">
                Événements à venir
              </h2>
              <p className="mt-6 text-slate-600 text-lg leading-relaxed">
                Rejoignez-nous lors de nos rencontres, retraites et célébrations. Chaque événement est
                une occasion de grandir ensemble dans la foi et la communion.
              </p>
              <div className="mt-8 rounded-2xl overflow-hidden aspect-[4/3]">
                <img src={IMG} alt="Communauté" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-5" data-testid="events-list">
            {events.length === 0 && (
              <div className="text-center py-24 text-slate-500 border-2 border-dashed border-slate-200 rounded-2xl">
                Aucun événement à venir. Restez connectés !
              </div>
            )}
            {events.map((e) => {
              const d = formatEventDate(e.date);
              return (
                <article key={e.id} className="group flex gap-6 p-6 rounded-2xl bg-white border border-slate-100 card-lift" data-testid={`event-${e.id}`}>
                  <div className="flex-shrink-0 w-20 h-20 rounded-xl bg-deepblue-900 text-white flex flex-col items-center justify-center border-t-4 border-gold">
                    <span className="font-serif text-3xl leading-none">{d.day}</span>
                    <span className="text-[10px] uppercase tracking-widest text-gold mt-1">{d.month}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    {e.category && (
                      <div className="text-[10px] font-bold uppercase tracking-widest text-gold-dark">{e.category}</div>
                    )}
                    <h3 className="font-serif text-xl sm:text-2xl text-deepblue-900 mt-1 leading-snug group-hover:text-gold-dark transition-colors">
                      {e.title}
                    </h3>
                    {e.description && <p className="mt-2 text-slate-600 text-sm">{e.description}</p>}
                    <div className="mt-4 flex flex-wrap items-center gap-4 text-sm text-slate-500">
                      <span className="inline-flex items-center gap-1.5">
                        <Calendar className="w-3.5 h-3.5" /> {d.full} · {d.time}
                      </span>
                      <span className="inline-flex items-center gap-1.5">
                        <MapPin className="w-3.5 h-3.5" /> {e.location}
                      </span>
                    </div>
                  </div>
                  <ArrowRight className="hidden sm:block w-5 h-5 text-slate-300 group-hover:text-gold group-hover:translate-x-1 transition-all self-center" />
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
